<template>
    <div class="componentRoot" style="width: 100vw; overflow: hidden;">
        <LandingPageHeaderVue />

        <RouterView style="width: 100vw" />
    </div>
</template>



<script>
import LandingPageHeaderVue from '../../components/navigation/LandingPageHeader.vue';

export default {
    name: "mainRoot",

    data() {
        return {

        }
    },

    components: {
        LandingPageHeaderVue
    },

    computed: {
        mainCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 12;
                case "sm":
                    return 12;
                case "md":
                    return 10;
                case "lg":
                    return 8;
                case "xl":
                    return 8;
                case "xxl":
                    return 6;
                default:
                    return 6;
            }
        },
        isMobile() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return true;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
    },

    methods: {

    }
}

</script>